import React from 'react';

import menu from '../../../../assets/images/icons/menu.svg';
import pinDrop from '../../../../assets/images/icons/pin_drop.svg';
import starRate from '../../../../assets/images/icons/star_rate.svg';

export const MenuIcon = () => (
  <img src={menu} alt="menu icon" />
);

export const PinDropIcon = () => (
  <img src={pinDrop} id="flying-destination" alt="pin icon" />
);

export const StarRateIcon = () => (
  <img src={starRate} alt="star rating icon" />
);
